export default function Garantias() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-6">Política de Garantías y Devoluciones</h1>

      <p className="mb-4">
        Nuestros productos cuentan con garantía legal según la normatividad vigente.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Garantía</h2>
      <p className="mb-4">
        Todos los productos tienen garantía por defectos de fabricación. No cubre daños por uso indebido.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Devoluciones</h2>
      <p className="mb-4">
        Cuentas con 5 días hábiles para solicitar cambios si el producto llegó defectuoso o no corresponde.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Reembolsos</h2>
      <p>
        Los reembolsos se procesan en un plazo de 5–10 días hábiles una vez aprobada la solicitud.
      </p>
    </div>
  );
}
